import './VendorSchools.css'
import { useEffect, useState, useRef } from 'react'
import { TextField, Dialog, DialogTitle, DialogContent, IconButton, InputAdornment, Typography, Button, Box } from '@mui/material'
import { QRCodeCanvas } from 'qrcode.react';
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { Tooltip } from '@mui/material';
// Components
import StandardPageWrapper from '../../components/StandardPageWrapper/StandardPageWrapper'
import StandardOutlinedTextfield from '../../components/StandardOutlinedTextfield/StandardOutlinedTextfield'
import ReactCustomTable from '../../components/ReactCustomTable/ReactCustomTable'
import StandardMuiDialogWrapper from '../../components/StandardMuiDialogWrapper/StandardMuiDialogWrapper'
// ICONs & SVGs
import { Edit, Visibility, ArrowForward, Download, ContentCopy } from '@mui/icons-material'

function VendorSchools() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [allSchoolData, setAllSchoolData] = useState([]);
  const [allSchoolDataLoading, setAllSchoolDataLoading] = useState(true);
  // Search
  const [searchInput, setSearchInput] = useState("");
  
  // Edit
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogBtnLoading, setDialogBtnLoading] = useState(false);
  const [editActive, setEditActive] = useState(false);
  const [editId, setEditId] = useState('');
  const [addSchoolData, setAddSchoolData] = useState({
    name: '', address: '', school_login_id: '', secret_code: '', contact_person: '', del_address: '', con_mobile: '', final_count: ''
  });
  
  //Show QR
  const [qrOpen, setQrOpen] = useState(false);
  const [qrData, setQrData] = useState("");
  const qrRef = useRef(null);
  const [qrFileName, setQrFileName] = useState("");

  useEffect(() => {
    fetchVendorSchools();
  }, [])

  const fetchVendorSchools = async () => {
    try {
      // Get vendor info from sessionStorage
      const userData = sessionStorage.getItem('ID_CardAdmin_user');
      if (!userData) {
        enqueueSnackbar('Vendor information not found', { variant: 'error' });
        setAllSchoolDataLoading(false);
        return;
      }

      const vendorInfo = JSON.parse(userData);
      const mobileNo = vendorInfo.phone_no;

      if (!mobileNo) {
        enqueueSnackbar('Phone number not found', { variant: 'error' });
        setAllSchoolDataLoading(false);
        return;
      }

      await axios.get(`${process.env.REACT_APP_BASE_URL}/user/getallschoolforvendor/${mobileNo}`)
        .then(res => {
          if (res.data.success) {
            setAllSchoolData(res.data.data || []);
          } else {
            enqueueSnackbar(res.data.message || 'Error Fetching Schools, Try Again !!!', { variant: 'error' })
          }
          setAllSchoolDataLoading(false);
        })
        .catch(err => {
          console.log(err);
          setAllSchoolDataLoading(false);
          enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
        })
    } catch (error) {
      console.log(error);
      setAllSchoolDataLoading(false);
      enqueueSnackbar('Error parsing vendor information', { variant: 'error' })
    }
  }

  const onExited = () => {
    setAddSchoolData({ name: '', address: '', school_login_id: '', secret_code: '', contact_person: '', del_address: '', con_mobile: '', final_count: '' });
    setEditActive(false);
  }

  const onEdit = (e, data) => {
    e.stopPropagation();
    if (!data.schoolid) return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' })
    setEditId(data.schoolid);
    setOpenDialog(true);
    setEditActive(true);
    setAddSchoolData({
      name: data?.name, address: data?.address, school_login_id: data?.school_login_id, secret_code: data?.secret_code,
      contact_person: data?.contact_person, del_address: data?.del_address, con_mobile: data?.con_mobile, final_count: data?.final_count
    })
  }

  const onSaveEdit = async () => {
    if (!editId) return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' })
    if (Object.values(addSchoolData)?.includes('')) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' })

    setDialogBtnLoading(true);

    let body = { ...addSchoolData, schoolid: editId }
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updateschool`, body)
      .then(res => {
        if (res.data.success) {
          const editDataIndex = allSchoolData.findIndex(i => i.schoolid == editId);
          if (editDataIndex === -1) return enqueueSnackbar('Error Updating School !!!', { variant: 'success' })

          let arr = [...allSchoolData]
          arr[editDataIndex] = body;
          setAllSchoolData(arr)
          enqueueSnackbar('School Updated Successfully !!!', { variant: 'success' })
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' })
        }
        setOpenDialog(false);
        setEditActive(false);
        setDialogBtnLoading(false);
        setEditId('');
        setAddSchoolData({ name: '', address: '', school_login_id: '', secret_code: '', contact_person: '', del_address: '', con_mobile: '' });
      })
      .catch(err => {
        console.log(err);
        setDialogBtnLoading(false);
        return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
      })
  }

  const showQr = (e, data) => {
    e.stopPropagation();
    const link = `https://gjaaipublication.com/login?school_login_id=${data.school_login_id}&school_secret=${data.school_secret}`;
    setQrData(link);
    setQrFileName(`${data.name}`);
    setQrOpen(true);
  };

  const downloadQRCode = () => {
    if (!qrRef.current) return;

    const canvas = qrRef.current.querySelector('canvas');
    if (!canvas) return;

    const url = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = url;
    link.download = `${qrFileName.replace(/[^a-z0-9]/gi, " ")}`;
    link.click();
  };

  const copyQRCode = async () => {
    if (!qrRef.current) return;

    const canvas = qrRef.current.querySelector('canvas');
    if (!canvas) return;

    // Full instructions text
    const instructionsText = `Step-1:

Download ID Solutions app on Playstore

OR

Click this Link:
https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication

Step-2:

Scan This QR For Login`;

    try {
      // Copy image to clipboard
      canvas.toBlob(async (blob) => {
        try {
          if (navigator.clipboard && window.ClipboardItem) {
            // Create a ClipboardItem with both image and text formats
            // Applications can choose which format to paste
            const clipboardItem = new window.ClipboardItem({
              'image/png': blob,
              'text/plain': new Blob([instructionsText], { type: 'text/plain' })
            });
            await navigator.clipboard.write([clipboardItem]);
            
            enqueueSnackbar('Instructions and QR Code copied to clipboard!', { variant: 'success' });
          } else {
            // Fallback: copy text only
            await navigator.clipboard.writeText(instructionsText);
            enqueueSnackbar('Instructions copied to clipboard! (Image copy not supported in this browser)', { variant: 'info' });
          }
        } catch (err) {
          console.error('Failed to copy with ClipboardItem:', err);
          // Fallback: copy text only
          await navigator.clipboard.writeText(instructionsText);
          enqueueSnackbar('Instructions copied to clipboard!', { variant: 'success' });
        }
      });
    } catch (err) {
      console.error('Failed to copy:', err);
      enqueueSnackbar('Failed to copy QR Code', { variant: 'error' });
    }
  };

  const onNavigatetoClass = (e, data) => navigate(`/vendor-schools/${data.schoolid}`, { state: data })

  const filterSchools = (data) => {
    return data.filter((school) => {
      const searchString = `${school.schoolid || ''} ${school.name || ''} ${school.address || ''} ${school.contact_person || ''}`.toLowerCase();
      return searchString.includes(searchInput.toLowerCase());
    });
  };

  const tableActions = [
    { icon: <Edit sx={{ cursor: 'pointer', color: '#7978e9' }} />, onClick: onEdit },
    { icon: <Visibility sx={{ cursor: 'pointer', color: 'blue' }} />, onClick: showQr },
    { icon: <ArrowForward sx={{ cursor: 'pointer' }} color='primary' />, onClick: onNavigatetoClass },
  ]

  return (
    <StandardPageWrapper
      header="Schools"
    >
      <TextField
        sx={{ marginRight: "30px", marginLeft: "10px", marginBottom: 2 }}
        variant="outlined"
        type="text"
        fullWidth
        placeholder="Search Schools..."
        value={searchInput}
        onChange={(e) => setSearchInput(e.target.value)}
      />
      <div id="vendor-schools">
        <ReactCustomTable
          data={filterSchools(allSchoolData)}
          tableColumns={tableColumns}
          loading={allSchoolDataLoading}
          tableActions={tableActions}
          actionsColumnWidth={200}
        />
      </div>

      <Dialog open={qrOpen} onClose={() => setQrOpen(false)}  >
        <DialogTitle>School QR Code</DialogTitle>
        <DialogContent sx={{ padding: "10px" }}>
          {/* Step-1 */}
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#7978e9' }}>
            Step-1:
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Download ID Solutions app on Playstore
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, fontWeight: 'bold' }}>
            OR
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Click this Link:{' '}
            <a 
              href="https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: '#7978e9', textDecoration: 'none' }}
            >
              https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication
            </a>
          </Typography>

          {/* Step-2 */}
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#7978e9' }}>
            Step-2:
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Scan This QR For Login
          </Typography>

          {/* QR Code Display */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <div ref={qrRef}>
              {qrData ? (
                <QRCodeCanvas value={qrData} size={220} includeMargin={true} />
              ) : (
                <p>No QR Data</p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={downloadQRCode}
              startIcon={<Download />}
            >
              Download QR
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={copyQRCode}
              startIcon={<ContentCopy />}
            >
              Copy
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <StandardMuiDialogWrapper
        open={openDialog}
        setOpen={setOpenDialog}
        onExited={onExited}
        dialogTitle="Update Schools"
        onSaveBtnClick={onSaveEdit}
        saveBtnLabel="Update"
        saveBtnLoading={dialogBtnLoading}
      >
        <TextField
          label="School Name"
          variant="outlined"
          name="name"
          value={addSchoolData.name}
          fullWidth
          sx={{ marginTop: 1.5 }}
          onChange={(e) => setAddSchoolData({ ...addSchoolData, [e.target.name]: e.target.value })}
        />
        <StandardOutlinedTextfield
          label="School Address"
          name="address"
          val={addSchoolData.address}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="School Login ID"
          name="school_login_id"
          val={addSchoolData.school_login_id}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="School Password"
          name="secret_code"
          val={addSchoolData.secret_code}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Contact Person Name"
          name="contact_person"
          val={addSchoolData.contact_person}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Delivery Address"
          name="del_address"
          val={addSchoolData.del_address}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Contact Person Mobile No"
          name="con_mobile"
          val={addSchoolData.con_mobile}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Final Count"
          name="final_count"
          val={addSchoolData.final_count}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
      </StandardMuiDialogWrapper>
    </StandardPageWrapper>
  );
}

export default VendorSchools

const tableColumns = [
  {
    label: 'School ID',
    key: 'schoolid',
    width: 100,
    align: 'center'
  },
  {
    label: 'Name',
    key: 'name',
    width: 250,
    fixed: false,
  },
  {
    label: 'Login ID',
    key: 'school_login_id',
    width: 150,
    fixed: false,
  },
  {
    label: 'Password',
    key: 'school_secret',
    width: 150,
    fixed: false,
  },
  {
    label: 'Pending IDs',
    key: 'pending_count',
    width: 100,
    align: 'center'
  },
  {
    label: 'Verified IDs',
    key: 'verified_count',
    width: 100,
    align: 'center'
  },
  {
    label: 'Verified Downloaded',
    key: 'verified_is_downloaded',
    width: 120,
    align: 'center',
    render: () => 0
  },
  {
    label: 'Verified Not Downloaded',
    key: 'verified_not_downloaded',
    width: 140,
    align: 'center',
    render: () => 0
  },
  {
    label: 'Total Count',
    key: 'final_count',
    width: 100,
    align: 'center'
  },
  {
    label: 'Address',
    key: 'address',
    flexGrow: 1,
    fullText: true,
    minWidth: 200,
  },
  {
    label: 'Contact Person Name',
    key: 'contact_person',
    width: 200,
    fixed: false,
    fullText: true,
  },
  {
    label: 'Delivery Address',
    key: 'del_address',
    width: 150,
    fixed: false,
    fullText: true,
  },
  {
    label: 'Contact Person Mobile No',
    key: 'con_mobile',
    width: 150,
    fixed: false,
    fullText: true,
  }
]

